import {
  REQUEST_FAQ_LIST,
} from './mutation-types';
  
import axiosInst from '@/utility/axiosInst';
  
export default {
  requestFaqList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/faq/get-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_FAQ_LIST, res.data)
    })
  },
}